// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tl-0";